import React from 'react';
import propTypes from 'prop-types';
import { intlShape } from 'react-intl';
import Markdown from 'markdown-to-jsx';
import { LinkExternalWithHref } from 'cstar-react-primitives/lib/redux-form/LinkExternalWithHref';
import { CheckboxToggle } from 'cstar-react-primitives/lib/redux-form/microFields/CheckboxToggle';
import { FieldDivWrapper } from 'cstar-react-primitives/lib/redux-form/layout/FieldLayout';
import { Field } from 'redux-form/immutable';

import paymentMessages from './paymentMessages';
import { ACCEPTED_CARDHOLDER_AGREEMENT } from '../consent/consentModule';

export const CardholderAgreement = ({ format, id, intl }) => {
    const checkboxProps = {
        name: ACCEPTED_CARDHOLDER_AGREEMENT,
        label: intl.formatMessage(paymentMessages.cardholderAgreementExplicit),
        component: CheckboxToggle,
        openLinksInNewTab: true,
        styleType: 'checkbox',
        cashbotName: 'cardholder-agreement',
        isRequiredField: true
    };
    switch (format) {
        case 'IMPLICIT':
            return (
                <div id={id} className='payment-cardholder-agreement'>
                    <Markdown
                        options={{
                            overrides: {
                                
                                a: {
                                    component: LinkExternalWithHref
                                }
                            }
                        }}
                    >
                        {intl.formatMessage(paymentMessages.cardholderAgreementImplicit)}
                    </Markdown>
                </div>
            );
        case 'EXPLICIT':
            return (
                <div id={id} className='payment-cardholder-agreement'>
                    <FieldDivWrapper>
                        <Field {...checkboxProps} />
                    </FieldDivWrapper>
                </div>
            );
        default:
            return null;
    }
};

CardholderAgreement.defaultProps = {
    id: null
};

CardholderAgreement.propTypes = {
    format: propTypes.string.isRequired,
    id: propTypes.string,
    intl: intlShape.isRequired
};
